import React from 'react'
import {Col, Row, VertContainer, VertSkeleton} from "@vertem-core/vertice-ds";
import MediaQuery from "react-responsive";

const StoreListPlaceholder = () => {
    const makeItemsForLoad = (numberItems) => {
        const items = [];
        for (let i = 0; i < numberItems; i++) {
            items.push((
                <Col xs={12} sm={12} md={8} lg={8} xl={6} className="padding-y-extra-small">
                    <div className="vert-card-store">
                        <Row shape="round" className="vert-card-store-wrapper" gutter={0}>
                            <Col className="vert-card-store-box-image col-12 col-md-3 padding-x-extra-small">
                                <MediaQuery minWidth={769}>
                                    <VertSkeleton.Avatar style={{
                                        width: '82px',
                                        height: '82px'
                                    }} shape={'circle'} />
                                </MediaQuery>
                                <MediaQuery maxWidth={768}>
                                    <VertSkeleton.Avatar style={{
                                        width: '46px',
                                        height: '46px'
                                    }} shape={'circle'} />
                                </MediaQuery>
                            </Col>
                            <Col className="vert-card-store-box-content col-12 col-md-9 padding-x-extra-small">
                                <VertSkeleton paragraph={{rows: 2}}/>
                            </Col>
                        </Row>
                    </div>
                </Col>
            ))
        }
        return items
    }
    return (
        <VertContainer className="vert-container-page" spacingX="regular" spacingY="regular">
            <Row justify="center" align="middle" className="vert-category vert-category-title margin-bottom-extra-small" gutter={8}>
                <Col className="vert-category vert-category-title-label col">
                    <VertSkeleton paragraph={{ rows: 0 }} />
                </Col>
            </Row>
            <Row gutter={16}>
                {makeItemsForLoad(7)}
            </Row>
            <Row justify="center" align="middle" className="vert-category vert-category-title margin-top-big margin-bottom-small" gutter={8}>
                <Col className="vert-category vert-category-title-label col">
                    <VertSkeleton paragraph={{ rows: 0 }} />
                </Col>
            </Row>
            <Row gutter={16}>
                {makeItemsForLoad(51)}
            </Row>
        </VertContainer>
    )
}

export default StoreListPlaceholder
